import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../../../../utils/styles';
import { AccountManagementRes, accountManagementSubCol } from '../../columns';

interface ICustomSubTable {
  item: AccountManagementRes;
  activeRows: string[];
}

function CustomSubTable({ item, activeRows }: ICustomSubTable) {
  const navigate = useNavigate();

  return (
    <div className={cn('hidden', { block: activeRows.includes(item.id) })}>
      <div className="grid grid-cols-3 h-[40px] text-xs uppercase text-label items-center border-b">
        {accountManagementSubCol.map(({ name, id }, idx) => (
          <div key={id} className={cn({ 'pl-[40px]': idx === 0 })}>
            {name}
          </div>
        ))}
      </div>
      {item.subRows.map(el => (
        <div key={el.id} className="hover:bg-[#d8dfe1]">
          <a
            href={`/infoTrac/account-management/${el.id}`}
            onClick={e => {
              e.preventDefault();
              navigate(`/infoTrac/account-management/${el.id}`);
            }}
            className={
              'grid grid-cols-3 h-[50px] items-center border-b transition ' +
              'hover:translate-x-[-10px] hover:font-medium'
            }
          >
            <div className="pl-[40px]">{el.cif}</div>
            <div>{el.name}</div>
            <div>{el.email}</div>
          </a>
        </div>
      ))}
    </div>
  );
}

export default CustomSubTable;
